import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog, SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog, } from "../models/models_0";
import { de_SearchPlaceIndexForSuggestionsCommand, se_SearchPlaceIndexForSuggestionsCommand, } from "../protocols/Aws_restJson1";
export { $Command };
export class SearchPlaceIndexForSuggestionsCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("LocationService", "SearchPlaceIndexForSuggestions", {})
    .n("LocationClient", "SearchPlaceIndexForSuggestionsCommand")
    .f(SearchPlaceIndexForSuggestionsRequestFilterSensitiveLog, SearchPlaceIndexForSuggestionsResponseFilterSensitiveLog)
    .ser(se_SearchPlaceIndexForSuggestionsCommand)
    .de(de_SearchPlaceIndexForSuggestionsCommand)
    .build() {
}
